<template>
  <section>

<!------POP UP---------->

    <b-modal
      v-model="modal"
      size="lg"
      modal-class="border-0"
      header-class="background-primary"
      footer-class="justify-content-center"
      v-bind:centered="true"
      v-bind:hide-footer="true"
    >
      <template slot="modal-header">
        <h4
          class="container text-uppercase text-white font-weight-bold text-center mb-0"
        >
          Tutorial Pengerjaan dan Pembahasan Try Out UTBK BTA Group
        </h4>
      </template>
      <div class="container text-center px-5 py-2">
        <template v-if="profile.student.branchID <= 17">
          <iframe
              src="https://www.youtube.com/embed/_ZHI-F93aaU?" width="320" height="240" frameborder="0" allowfullscreen="allowfullscreen"
              alt="videoTO"
          /></iframe>
          <!--<a href="https://bit.ly/surveiS1bta2021"><img src="/static/images/page/about/surveiS1.jpg" alt="surveiS1" border="0" width ="100%"></a> -->
        </template>
        <template v-if="profile.student.branchID >= 17">
          <iframe
              src="https://www.youtube.com/embed/_ZHI-F93aaU?" width="320" height="240" frameborder="0" allowfullscreen="allowfullscreen"
              alt="videoTO"
          /></iframe>
        </template>

        <!--<a href="#"><img src="https://i.ibb.co/gj8hmz3/posterTO.jpg" alt="posterTO" border="0" width ="100%"></a>-->
        <button
          v-on:click="modal = false"
          class="btn btn-sm btn-outline-danger px-5 mt-2 mb-3 d-block mx-auto"
        >
          Tutup
        </button>
      </div>
    </b-modal>

<!-------------->

    <div class="row">
      <div class="col-10 offset-1">
        <nav aria-label="breadcrumb">
          <ul class="breadcrumb mt-5">
            <li
              class="breadcrumb-item h3 font-weight-bold mb-0 active"
              aria-current="page"
            >
              Tryout
            </li>
          </ul>
        </nav>
        <div class="row">
          <!--<template
            v-if="
              profile.student.branchID == 53 ||
              profile.student.branchID == 13 ||
              profile.student.branchID == 14
            "
          >-->
          <div
            class="col-xl-3 col-md-4 col-sm-6"
            v-for="(tryout, index) in tryouts"
            v-if="tryout.isSimak != 1"
            v-bind:key="tryout.id"
          >
            <div class="card shadow-sm mb-4 border-0 wrapper">
              <div class="card-header background-primary">
                <div class="row justify-content-end">
                  <div class="col">&nbsp;</div>
                </div>
              </div>
              <div class="card-body">
                <div class="card-title text-muted mb-0">Nama TO:</div>
                <p class="mb-2 d-block text-loading">
                  <template v-if="tryout.name">{{ tryout.name }}</template>
                </p>
                <div class="card-title text-muted mb-0">Tanggal TO:</div>
                <p class="mb-2">
                  {{
                    [tryout.tryoutOnline.start, "YYYY-MM-DD HH:mm:ss"]
                      | moment("D MMMM YYYY - HH.mm")
                  }}
                  s/d
                  {{
                    [tryout.tryoutOnline.end, "YYYY-MM-DD HH:mm:ss"]
                      | moment("D MMMM YYYY - HH.mm")
                  }}
                </p>
              </div>
              <router-link
                v-bind:to="
                  tryout.tryoutOnline.isOpen
                    ? { name: 'tryout/view', params: { id: tryout.id } }
                    : '#'
                "
                class="card overlay"
                v-bind:class="{ open: tryout.tryoutOnline.isOpen }"
              >
                <div class="content my-auto px-3">
                  <div class="card-title text-white mb-0 text-center">
                    Tanggal TO:
                  </div>
                  <p class="mb-2 text-white text-center">
                    {{
                      [tryout.tryoutOnline.start, "YYYY-MM-DD HH:mm:ss"]
                        | moment("D MMMM YYYY - HH.mm")
                    }}
                    s/d
                    {{
                      [tryout.tryoutOnline.end, "YYYY-MM-DD HH:mm:ss"]
                        | moment("D MMMM YYYY - HH.mm")
                    }}
                  </p>
                </div>
              </router-link>
            </div>
          </div>
          <!--</template>-->
        </div>
        <nav aria-label="breadcrumb">
          <ul class="breadcrumb mt-5">
            <li
              class="breadcrumb-item h3 font-weight-bold mb-0 active"
              aria-current="page"
            >
              Asesmen Bidang Studi
            </li>
          </ul>
        </nav>
        <div class="row">
          <div
            class="col-xl-3 col-md-4 col-sm-6"
            v-for="(tryout, index) in tryouts"
            v-if="tryout.isSimak == 1"
            v-bind:key="tryout.id"
          >
            <div class="card shadow-sm mb-4 border-0 wrapper">
              <div class="card-header background-primary">
                <div class="row justify-content-end">
                  <div class="col">&nbsp;</div>
                </div>
              </div>
              <div class="card-body">
                <div class="card-title text-muted mb-0">Nama TO:</div>
                <p class="mb-2 d-block text-loading">
                  <template v-if="tryout.name">{{ tryout.name }}</template>
                </p>
                <div class="card-title text-muted mb-0">Tanggal TO:</div>
                <p class="mb-2">
                  {{
                    [tryout.tryoutOnline.start, "YYYY-MM-DD HH:mm:ss"]
                      | moment("D MMMM YYYY - HH.mm")
                  }}
                  s/d
                  {{
                    [tryout.tryoutOnline.end, "YYYY-MM-DD HH:mm:ss"]
                      | moment("D MMMM YYYY - HH.mm")
                  }}
                </p>
              </div>
              <router-link
                v-bind:to="
                  tryout.tryoutOnline.isOpen
                    ? { name: 'tryout/view', params: { id: tryout.id } }
                    : '#'
                "
                class="card overlay"
                v-bind:class="{ open: tryout.tryoutOnline.isOpen }"
              >
                <div class="content my-auto px-3">
                  <div class="card-title text-white mb-0 text-center">
                    Tanggal TO:
                  </div>
                  <p class="mb-2 text-white text-center">
                    {{
                      [tryout.tryoutOnline.start, "YYYY-MM-DD HH:mm:ss"]
                        | moment("D MMMM YYYY - HH.mm")
                    }}
                    s/d
                    {{
                      [tryout.tryoutOnline.end, "YYYY-MM-DD HH:mm:ss"]
                        | moment("D MMMM YYYY - HH.mm")
                    }}
                  </p>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col text-center mt-5">
        <Adsense
          v-bind:data-ad-client="googleAdsClientKey"
          data-ad-slot="6426122373"
        ></Adsense>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "TryoutIndex",

  computed: mapState(["profile"]),

  data() {
    return {
      tryouts: [],
      modal: true,
      student: { user: {}, branch: {}, school: {}, btaGrade: {} },
      googleAdsClientKey: process.env.GOOGLE_ADS_CLIENT,
    };
  },

  created() {
    this.axios.get(process.env.API_URL + "/tryout").then((response) => {
      this.tryouts = response.data.data;
    });

    document.title = "Tryout Online - " + process.env.APP_NAME;
  },
};
</script>

<style scoped>
.card.wrapper .overlay.open {
  background-color: transparent;
  pointer-events: fill;
}
.card.wrapper .overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 2;
  pointer-events: none;
}
.card.wrapper .overlay.open .content {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/tryout/Index.vue